import React from "react";

import { CancelRounded } from "@mui/icons-material";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from "@mui/material";

import { ActivationAudience } from "@/types";

interface AudienceCardProps {
  audience: ActivationAudience;
  onSelect(audience: ActivationAudience): void;
  disabled: boolean;
  color?: string;
}

const ActivationAudienceCard: React.FC<AudienceCardProps> = ({
  audience,
  onSelect,
  disabled,
  color
}) => {
  return (
    <Box sx={{ position: "relative" }}>
      <Card
        sx={{
          width: "140px",
          border: color ? `2px solid ${color}` : undefined
        }}
      >
        <CardActionArea
          onClick={() => onSelect(audience)}
          disabled={disabled}
          sx={{
            position: "relative",
            "&:hover .card-overlay": {
              opacity: 1,
            },
            "&:hover .card-content": {
              opacity: 0.2,
            },
          }}
        >
          <CardContent
            className="card-content"
            sx={{
              height: 80,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              transition: "opacity 0.3s",
              opacity: disabled ? 0.5 : 1,
            }}
          >
            <Typography
              variant="body1"
              textAlign="center"
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: "2",
                WebkitBoxOrient: "vertical",
              }}
            >
              {audience.audience_name}
            </Typography>
          </CardContent>

          <Box
            className="card-overlay"
            sx={{
              position: "absolute",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              top: 0,
              right: 0,
              height: 80,
              width: 140,
              opacity: 0,
              transition: "opacity 0.3s",
              zIndex: 2,
            }}
          >
            <CancelRounded fontSize="large" />
          </Box>
        </CardActionArea>
      </Card>
    </Box>
  );
};

export default ActivationAudienceCard;
